import './SectionFeedsFooter.scss';
import { ReactElement } from 'react';
import cn from 'classnames';
import { dateToLongDate } from '@src/utils/date-utils';

interface SectionFeedsFooterProps {
  icon: ReactElement;
  feedsCopy: string;
  updatedAt?: string;
  updatedByName?: string;
  className?: string;
}

// Names what the section feeds, and when it last changed.
export const SectionFeedsFooter = ({
  icon,
  feedsCopy,
  updatedAt,
  updatedByName,
  className
}: SectionFeedsFooterProps) => (
  <div className={cn('section-feeds-footer', className)}>
    <span className='section-feeds-footer-icon'>{icon}</span>
    <span className='section-feeds-footer-feeds'>{feedsCopy}</span>
    {updatedAt && (
      <span className='section-feeds-footer-updated'>
        updated {dateToLongDate(updatedAt)}
        {updatedByName && ` by ${updatedByName}`}
      </span>
    )}
  </div>
);
